/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {Spinner} from "react-bootstrap";
import {HorizontalTabs} from "../../../components/Tabs/HorizontalTabs";
import React, {useEffect, useState} from 'react';
import {useSearchParams} from "react-router-dom";
import ObjectDetailsTab from './ObjectDetailsTab';
import {useAppSelector} from "../../../../redux/hooks";
import {selectGlobalDialogState} from "../../../../redux/ducks/GlobalDialog/slice";
import CloseGlobalDialogButton from "../../../components/Global/Dialog/CloseGlobalDialogButton";
import {ArgosFavoriteIconLogic} from "../../../components/Buttons/ArgosFavoriteIconLogic";
import {Toolbar, Typography} from '@mui/material';
import {usePostRequest} from "../../../../api/helper";
import {fetchObjectsEndpoint} from "../constants";
import {ETrackedItemTypes} from "../../../../constants/trackedItems";


const ObjectDetails = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [tabs, setTabs] = useState<any>([])
  const [title, setTitle] = useState("");
  const [searchParams, _] = useSearchParams();
  const urlParams = Object.fromEntries(searchParams)
  const params: any = useAppSelector(state => {
    const dialogState = selectGlobalDialogState(state)
    if (dialogState.isOpen) {
      return dialogState.component?.params ?? urlParams
    } else return urlParams
  })
  const objectId = params?.id

  useEffect(() => {
    fetchBaselineData()
  }, [])
  const fetchBaselineDataHandle = usePostRequest(fetchObjectsEndpoint)
  const fetchBaselineData = async () => {
    setIsLoading(true)
    fetchBaselineDataHandle({"id": objectId})
      .then((data) => {
        processData(data)
      })
      .finally(() => setIsLoading(false))
  }
  const processData = (objectData: any[]) => {
    const localTabs: any[] = []
    const type = objectData[0]?.type
    const name = objectData[0]?.name
    setTitle(`${type}: ${name}`)
    const objectDetailsContent = <ObjectDetailsTab objectData={objectData} isCustomObject={type === "Custom"}/>
    localTabs.push({'name': 'Object Details', 'content': objectDetailsContent})
    setTabs(localTabs)
  }

  const icons = (
    <div style={{display: 'flex', alignItems: 'center'}}>
      <CloseGlobalDialogButton/>
    </div>
  )

  return (<>
    <div style={{height: '100%', width: '100%', display: 'flex', flexFlow: 'column nowrap', overflow: 'auto'}}>
      <div>
        <Toolbar variant="dense" style={{justifyContent: "space-between", background: '#3481d5', height: "100%"}}>
          <Typography sx={{color: '#ffffff', fontSize: 14}}>{title}</Typography>
          {icons}
        </Toolbar>
      </div>
      {isLoading ?
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%'}}>
          <Spinner animation={'border'} style={{color: 'grey'}}/>
        </div>
        :
        <div style={{height: '100%', overflow: 'auto', display: 'flex', justifyContent: 'space-between'}}>
          <HorizontalTabs initContent={null} initHtabIndex={0} horizontalTabs={tabs} align={'left'}
                          favoriteType={ETrackedItemTypes.OBJECT} uid={'htabs-1'}/>
          <div style={{marginRight: 20, marginTop: 20}}>
            <ArgosFavoriteIconLogic
              favoriteType={ETrackedItemTypes.OBJECT}
              trackedItemUid={objectId}
              //if vtabs aren't loaded dont show, here we only have htabs. could use redux, could just use htabs. could show delay instead.
              isLoading={isLoading || !(tabs?.length > 0)}
              partitionKey={'Jama'}
            />
          </div>
        </div>
      }
    </div>
  </>)
}
export default ObjectDetails
